<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <div class="customer-tab">
        <div slot="no-body" class="tabs-container pt-6" id="view-customer-tab">
          <div>
            <div class="vx-col w-full text-center mb-2">
              <vs-radio
                v-model="showBtnRadioTransfer"
                vs-value="Item"
                color="primary"
                class="mr-3"
                @change="viewMRNStockTransfer"
                >{{ $t("inventory.label.ItemSale") }}</vs-radio
              >
              <vs-radio
                v-model="showBtnRadioTransfer"
                color="primary"
                vs-value="MRN"
                class="mr-3"
                @change="viewMRNStockTransfer"
                >{{ $t("inventory.label.MRN") }}</vs-radio
              >
              <vs-radio
                v-model="showBtnRadioTransfer"
                color="primary"
                vs-value="GRV"
                @change="viewMRNStockTransfer"
                >{{ $t("inventory.label.GRV") }}</vs-radio
              >
            </div>
            <vx-card>
              <div class="vx-row"></div>
              <vs-table
                :max-items="descriptionItems[0]"
                pagination
                :data="stockTransferData"
                description
                search
                @selected="transferHandleSelected"
                :description-items="descriptionItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="list-heading">
                    {{ $t("stockTransfer.label.header") }}
                  </div>

                  <div
                    class="mr-2 mb-1 order-1"
                    v-show="showBtnRadioTransfer === 'Item'"
                  >
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      size="small"
                      @click="$router.push({ name: 'Create Item Sale' })"
                      >{{
                        $t("stockTransfer.label.Create Item Sale")
                      }}</vs-button
                    >
                  </div>
                  <div
                    class="mr-2 mb-1 order-1"
                    v-show="showBtnRadioTransfer === 'MRN'"
                  >
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      size="small"
                      @click="$router.push({ name: 'Create MRN' })"
                      >{{ $t("stockTransfer.label.Create MRN") }}</vs-button
                    >
                  </div>
                  <div
                    class="mr-2 mb-1 order-1"
                    v-show="showBtnRadioTransfer === 'GRV'"
                  >
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      size="small"
                      @click="$router.push({ name: 'Create GRV' })"
                      >{{ $t("stockTransfer.label.Create GRV") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("stockTransfer.label.Id") }}</vs-th>
                  <vs-th>{{ $t("stockTransfer.label.Requested Date") }}</vs-th>
                  <vs-th>{{ $t("stockTransfer.label.Requested By") }}</vs-th>
                  <vs-th>{{ $t("stockTransfer.label.Request From") }}</vs-th>
                  <vs-th>{{
                    $t("stockTransfer.label.Item Description")
                  }}</vs-th>
                  <vs-th>{{
                    $t("stockTransfer.label.Ordered Quantity")
                  }}</vs-th>
                  <vs-th>{{
                    $t("stockTransfer.label.Received Quantity")
                  }}</vs-th>
                  <vs-th>{{ $t("inventory.label.status") }} </vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("inventory.label.action")
                  }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="stockTransferGood"
                    v-for="(stockTransferGood, index) in data"
                  >
                    <vs-td :data="stockTransferGood.id">{{
                      stockTransferGood.id
                    }}</vs-td>
                    <vs-td :data="getDate(stockTransferGood.requestedDate)">{{
                      getDate(stockTransferGood.requestedDate)
                    }}</vs-td>
                    <vs-td :data="stockTransferGood.toOffice">{{
                      stockTransferGood.toOffice
                    }}</vs-td>
                    <vs-td :data="stockTransferGood.fromOffice">{{
                      stockTransferGood.fromOffice
                    }}</vs-td>
                    <vs-td :data="stockTransferGood.itemDescription">{{
                      stockTransferGood.itemDescription
                    }}</vs-td>
                    <vs-td :data="stockTransferGood.orderdQuantity">{{
                      stockTransferGood.orderdQuantity
                    }}</vs-td>
                    <vs-td :data="stockTransferGood.receivedQuantity">{{
                      stockTransferGood.receivedQuantity
                    }}</vs-td>
                    <vs-chip
                      :color="
                        getOrderStatusColorStockTransfer(
                          stockTransferGood.orderdQuantity ==
                            stockTransferGood.receivedQuantity
                            ? 'Completed'
                            : 'Pending'
                        )
                      "
                      class="product-order-status"
                      style="margin-top: 8px"
                      >{{
                        stockTransferGood.orderdQuantity ==
                        stockTransferGood.receivedQuantity
                          ? "Completed"
                          : "Pending"
                      }}
                    </vs-chip>

                    <vs-td :data="stockTransferGood" class="whitespace-no-wrap"
                      ><div class="container_img">
                        <!-- <button
                          class="bGNone border-none view_editTable_btn"
                          @click.stop="
                            transferHandleSelected(stockTransferGood)
                          "
                        >
                          <feather-icon
                            icon="EyeIcon"
                            title="View"
                            svgClasses="w-5 h-5 text-danger stroke-current cursor"
                            class="icon_row"
                          />
                        </button> -->
                        <button
                          v-if="stockTransferGood.status !== 'Completed'"
                          class="border-none view_editTable_btn"
                          @click.stop="moveToCarton(stockTransferGood)"
                        >
                          <img
                            src="@/assets/images/icons/move_itmes.svg"
                            title="Move Carton"
                            class="h-5 w-5 icon_row"
                          />
                        </button>
                        <button
                          v-if="stockTransferGood.status == 'New'"
                          class="bGNone border-none view_editTable_btn"
                          @click.stop="
                            deletestocktransfer(stockTransferGood.id)
                          "
                        >
                          <feather-icon
                            icon="TrashIcon"
                            :title="$t('inventory.label.Delete')"
                            svgClasses="w-5 h-5 text-danger stroke-current cursor"
                            class="icon_row"
                          />
                        </button>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </div>
        </div>
      </div>
      <div class="centerx">
        <vs-popup
          class="popup-close"
          :title="$t('inventory.label.EditItemDetail')"
          :active.sync="updateCraditPopup"
        >
          <ValidationObserver ref="observer">
            <form>
              <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                <div class="vx-col sm:w-full w-full">
                  <div
                    v-if="details.status == 'Available'"
                    class="dropdown-with-label"
                  >
                    <small class="date-label font-semibold"
                      >{{ $t("stockUpload.label.add.Quality")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('stockUpload.label.add.Quality')"
                    >
                      <v-select
                        label="mCodeValue"
                        v-model="detail.quality"
                        :reduce="(obj) => obj.mCodeValue"
                        :options="details.qualityDatas"
                        :placeholder="$t('inventory.label.SelectItem')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="min-w-200 w-full mb-2 font-semibold"
                      >
                        <template v-slot:option="option">{{
                          option.mCodeValue
                        }}</template>
                      </v-select>
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('inventory.label.ProvisionSerialNumber')"
                  >
                    <vs-input
                      :label="$t('inventory.label.ProvisionSerialNumber')"
                      type="text"
                      class="w-full mb-2 font-semibold"
                      v-model="detail.provisioningSerialNumber"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('inventory.label.SerialNumber')"
                  >
                    <vs-input
                      v-if="details.status == 'Available'"
                      :label="$t('inventory.label.SerialNumber')"
                      type="text"
                      class="w-full mt-6 mb-2 font-semibold"
                      v-model="detail.serialNumber"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row my-2" style="margin-left: 20rem">
                <span class="ml-1 mr-2">
                  <vs-button icon-pack="feather" @click="saveQuality">{{
                    $t("inventory.label.Submit")
                  }}</vs-button>
                </span>
              </div>
            </form>
          </ValidationObserver>
        </vs-popup>
      </div>
      <div class="centerx">
        <vs-popup
          class="popup-close"
          :title="$t('inventory.label.TrackHistory')"
          :active.sync="updateCraditPopup1"
        >
          <form>
            <vs-table :data="historys">
              <template slot="thead">
                <vs-th>{{ $t("inventory.label.RefType") }}</vs-th>
                <vs-th>{{ $t("inventory.label.TransactionDate") }}</vs-th>
                <vs-th>{{ $t("inventory.label.Movement") }}</vs-th>
                <vs-th>{{ $t("inventory.label.FromOffice") }}</vs-th>
                <vs-th>{{ $t("inventory.label.ToOffice") }}</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr
                  :key="index"
                  :data="history"
                  v-for="(history, index) in data"
                >
                  <vs-td :data="history.refType">{{ history.refType }}</vs-td>
                  <vs-td :data="getDate(history.transactionDate)">{{
                    getDate(history.transactionDate)
                  }}</vs-td>
                  <vs-td :data="history.movement">{{ history.movement }}</vs-td>
                  <vs-td :data="history.fromOffice">{{
                    history.fromOffice
                  }}</vs-td>
                  <vs-td :data="history.toOffice">{{ history.toOffice }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <div class="vx-row float-right my-2">
              <span class="ml-1 mr-5">
                <vs-button type="border" @click="updateCraditPopup1 = false">{{
                  $t("inventory.label.Done")
                }}</vs-button>
              </span>
            </div>
          </form>
        </vs-popup>
      </div>

      <div class="centerx">
        <vs-popup
          class="popup-close"
          :title="$t('stockTransfer.label.Delete Item Sale')"
          :active.sync="editJobsPopup"
        >
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <div class="vx-col sm:w-full w-full">{{$t("inventory.label.Are_you_sure_?")}}</div>
            </div>
          </div>
          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="editJobsPopup = false">{{
                $t("stockTransfer.label.Cancel")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="deleteTeam(delId)" color="warning">{{
                $t("stockTransfer.label.Ok")
              }}</vs-button>
            </span>
          </div>
        </vs-popup>
      </div>
      <div class="centerx">
        <vs-popup
          class="popup-close"
          :title="deletePopupTitle"
          :active.sync="popupDeleteStockTransfer"
        >
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col sm:w-full w-full">
              <div class="vx-col sm:w-full w-full">{{$t("inventory.label.Are_you_sure_?")}}</div>
            </div>
          </div>
          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button
                type="border"
                @click="popupDeleteStockTransfer = false"
                >{{ $t("stockTransfer.label.Cancel") }}</vs-button
              >
            </span>
            <span class="ml-1 mr-2">
              <vs-button
                @click="deleteTeamTransfer(type, delId)"
                color="warning"
                >{{ $t("stockTransfer.label.Ok") }}</vs-button
              >
            </span>
          </div>
        </vs-popup>
      </div>
      <ConfirmDelete
        :title="deletePopupTitle"
        :isOpen="deleteItemPopup"
        @onCancel="deleteItemPopup = false"
        @onConfirm="deleteTeamTransfer(type, delId)"
      />
    </div>
  </div>
</template>
<script>
import {
  editGrnTemplate,
  viewGRVStockTransfer,
  getSqlSearch,
  getByItemDetailsTemplate,
  getByItemDetailsdropdown,
  deleteItemDetail,
  saveQuality,
  getMrnHistory,
  viewMRNStockTransfer,
  deleteItemSale,
} from "@/http/inventory";
import { AtomSpinner } from "epic-spinners";
import moment from "moment";
import vSelect from "vue-select";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Vendors from "./Vendors/Index.vue";
import Assets from "./Assets/Index.vue";
import confirmDelete from "@/components/common/confirmDelete";
import { mapState } from "vuex";

export default {
  components: {
    AtomSpinner,
    vSelect,
    ValidationObserver,
    ValidationProvider,
    Vendors,
    Assets,
    ConfirmDelete: confirmDelete,
  },
  data() {
    return {
      loading: false,
      editGrnPopup: false,
      resetKey: 0,
      searchOption: 0,
      purchaseDate: "",
      editOrderQty: 0,
      deleteItemPopup: false,
      selectedName: "",
      selectedDescription: "",
      selectedStatus: "",
      saveGrnPayload: {
        purchaseDate: "",
        orderdQuantity: "",
        locale: "en",
        dateFormat: "dd MMMM yyyy",
        purchaseNo: "",
        supplierId: "",
        officeId: "",
        itemMasterId: "",
      },
      descriptionItems: [10, 20, 30],
      value: ["Inactive", "New", "Success"],
      grn: {},
      goods: [],
      searches: [],
      updateCraditPopup: false,
      updateCraditPopup1: false,
      editJobsPopup: false,
      details: {},
      detail: {
        quality: "",
        serialNumber: "",
        provisioningSerialNumber: "",
      },
      qualityDatas: [],
      historys: {
        fromOffice: "",
        itemDescription: "",
      },
      history: [],
      stockTransferData: [],
      popupDeleteStockTransfer: false,
      showBtnRadioTransfer: "Item",
      type: "",
      deletePopupTitle: "",
    };
  },

  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
      filteredStockList: (state) => state.inventory.filteredStock,
    }),
  },
  methods: {
    deletestocktransfer(id) {
      if (this.showBtnRadioTransfer == "Item")
        this.deletePopupTitle = "Delete Item Sale";
      else if (this.showBtnRadioTransfer == "MRN")
        this.deletePopupTitle = "Delete MRN";
      else if (this.showBtnRadioTransfer == "GRV")
        this.deletePopupTitle = "Delete GRV";
      this.deleteItemPopup = true;
      this.delId = id.replace(/[^0-9]+/g, "");
      if (this.showBtnRadioTransfer == "Item") this.type = "itemsales";
      else if (this.showBtnRadioTransfer == "MRN") this.type = "mrn";
      else if (this.showBtnRadioTransfer == "GRV") this.type = "grv";
    },
    editData(id) {
      this.$router.push({ name: "Edit Goods Receipt", params: { id: id } });
    },
    handleSelected(good) {
      this.$router.push({
        name: "View Goods Receipt",
        params: { id: good.id },
      });
    },
    stockUploadClickView(item) {
      if (item.clientId)
        this.$router.push({
          name: "View Customer",
          params: { id: item.clientId },
        });
    },
    moveToCarton(data) {
      this.$router.push({
        name: "Move Item Sale MRN GRV",
        params: { id: data.id, item: data.itemDescription },
      });
    },
    getOrderStatusColor(status) {
      if (status === "Pending") return "orange";
      return "success";
    },
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    async viewGRVStockTransfer() {
      this.loading = true;
      try {
        const good = await viewGRVStockTransfer();
        this.goods = good.data.pageItems;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async haldleSelectedOption() {
      if (!this.selectedStatus) {
        this.selectedStatus = "";
      }
      if (!this.selectedName) {
        this.selectedName = "";
      }
      if (!this.selectedDescription) {
        this.selectedDescription = "";
      }
      if (
        !this.selectedStatus &&
        !this.selectedName &&
        !this.selectedDescription
      ) {
        this.getSqlSearch();
      }
      const data = {
        status: this.selectedStatus,
        entityName: this.selectedName,
        description: this.selectedDescription,
      };
      try {
        await this.$store.dispatch("inventory/stockUploadfilterAction", data);
        this.searches = this.filteredStockList.pageItems;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async saveGrn() {
      try {
        this.saveGrnPayload.purchaseDate = this.getDate(this.grn.purchaseDate);
        this.saveGrnPayload.orderdQuantity = this.editOrderQty;
        this.saveGrnPayload.purchaseNo = this.grn.purchaseNo;
        this.saveGrnPayload.supplierId = this.grn.supplierId;
        this.saveGrnPayload.officeId = this.grn.officeId;
        this.saveGrnPayload.itemMasterId = this.grn.itemMasterId;
        await editGrnTemplate(this.grn.id, this.saveGrnPayload);
        this.editGrnPopup = false;
        this.viewGRVStockTransfer();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getSqlSearch() {
      this.loading = true;
      try {
        const search = await getSqlSearch();
        this.searches = search.data.pageItems;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async editDataPopup(search) {
      const response = await getByItemDetailsTemplate();
      this.details = response.data;
      this.details["status"] = search.status;
      this.detail.serialNumber = search.serialNumber;
      this.detail.provisioningSerialNumber = search.Chipid;
      this.detail.quality = search.quality;
      this.itemId = search.id;
      this.resetKey++;
      this.updateCraditPopup = true;
    },
    async deleteTeam(id) {
      try {
        await deleteItemDetail(id);
        this.editJobsPopup = false;
        this.getSqlSearch();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getByItemDetailsTemplate() {
      this.loading = true;
      try {
        const response = await getByItemDetailsTemplate();
        this.details = response.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async viewTrakerPopup(id) {
      const history = await getMrnHistory(id);
      this.historys = history.data.pageItems;
      this.updateCraditPopup1 = true;
    },
    async getByItemDetailsdropdown() {
      this.loading = true;
      try {
        const item = await getByItemDetailsdropdown();
        this.items = item.data;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async saveQuality() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      const postItemObj = {
        quality: this.detail.quality,
        provisioningSerialNumber: this.detail.provisioningSerialNumber,
      };
      if (this.details.status == "Available") {
        postItemObj["serialNumber"] = this.detail.serialNumber;
      }
      try {
        this.updateCraditPopup = false;
        const resp = await saveQuality(this.itemId, postItemObj);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Item Detail Updated successfully!",
          type: "success",
        });
        if (resp.data.resourceId) {
          this.$router.push({
            name: "Goodsreceipt",
          });
        }
        this.viewGRVStockTransfer();
        this.getSqlSearch();
        this.getByItemDetailsTemplate();
        this.getByItemDetailsdropdown();
        this.viewMRNStockTransfer();
      } catch (e) {
        if (e.httpStatusCode) {
          this.errorMessage = e.errors[0].defaultUserMessage;
        }
      }
    },
    transferHandleSelected(stockTransferGood) {
      stockTransferGood.id = stockTransferGood.id.replace(/[{()}]/g, "");
      this.val = stockTransferGood.id.split(" ");
      if (this.val[0] === "MRN") {
        let mrnid = this.val[1];
        let type = "mrn";
        this.$router.push({
          name: "View MRN",
          params: { id: mrnid, type: type },
        });
      } else if (this.val[0] === "GRV") {
        let grvid = this.val[1];
        let type = "grv";
        this.$router.push({
          name: "View GRV",
          params: { id: grvid, type: type },
        });
      } else {
        let saleid = this.val[2];
        let type = "sales";
        this.$router.push({
          name: "View Stock Transfer",
          params: { id: saleid, type: type },
        });
      }
    },
    mrnData(stockTransferGood) {
      stockTransferGood.id = stockTransferGood.id.replace(/[{()}]/g, "");
      this.val = stockTransferGood.id.split(" ");
      if (this.val[0] === "MRN") {
        this.$router.push({ name: "Move MRN", params: { id: this.val[1] } });
      } else if (this.val[0] === "GRV") {
        this.$router.push({ name: "Move GRV", params: { id: this.val[1] } });
      } else {
        this.$router.push({ name: "Move Sales", params: { id: this.val[2] } });
        alert("sale", this.val[2]);
      }
    },
    getOrderStatusColorStock(status) {
      if (status === "Available") return "orange";
      return "success";
    },
    getOrderStatusColorStockTransfer(status) {
      if (status === "Pending") return "orange";
      return "success";
    },
    async viewMRNStockTransfer() {
      this.loading = true;
      try {
        const stockTransferGood = await viewMRNStockTransfer();
        let transferData = stockTransferGood.data.pageItems;
        this.stockTransferData = transferData.filter((stockData) => {
          let stockId = stockData.id.split(" ");
          if (stockId[0] == this.showBtnRadioTransfer) {
            return stockData;
          }
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },

    async deleteTeamTransfer(type, id) {
      try {
    await deleteItemSale(type, id);
    this.deleteItemPopup = false;
    this.$nextTick(() => {
      this.$swal({
        title: "Success",
        icon: "success",
        text:
          type === "itemsales"
            ? "Item Sale Deleted Successfully!"
            : type === "mrn"
            ? "MRN Deleted Successfully!"
            : "GRV Deleted Successfully!",
      });
      this.viewMRNStockTransfer();
    });
  } catch (error) {
    let errorMessage = "Something went wrong!";
    if (
      error &&
      error.message &&
      error.message.errors &&
      error.message.errors[0]
    ) {
      errorMessage = error.message.errors[0].defaultUserMessage;
    }

    this.$swal({
      title: "Error",
      icon: "error",
      text: errorMessage,
    });
  }
    },
  },
  mounted() {
    this.viewGRVStockTransfer();
    this.getSqlSearch();
    this.getByItemDetailsTemplate();
    this.getByItemDetailsdropdown();
    this.viewMRNStockTransfer();
  },
  watch: {
    editGrnPopup(newValue) {
      if (newValue) {
        this.viewGRVStockTransfer();
      }
    },
  },
};
</script>
<style scoped>
.inventory_tabSec >>> .con-vs-tabs .con-ul-tabs {
  width: 40%;
  margin: 0 auto;
  border: 1px solid #c5d0df;
  border-radius: 6px;
}
.inventory_tabSec >>> .vs-tabs-primary .con-ul-tabs .line-vs-tabs {
  background: linear-gradient(
    118deg,
    rgba(var(--vs-primary), 1),
    rgba(var(--vs-primary), 0.7)
  ) !important;
  box-shadow: none !important;
}
.inventory_tabSec >>> .vs-tabs-primary .con-ul-tabs .activeChild button {
  color: #fff !important;
}
.inventory_tabSec >>> .activeChild button.vs-tabs--btn {
  background: linear-gradient(
    118deg,
    rgba(var(--vs-primary), 1),
    rgba(var(--vs-primary), 0.7)
  );
  padding-top: 10px;
  padding-bottom: 10px;
}

.inventory_tabSec >>> .vs-tabs--ul {
  padding-top: 0;
}
.inventory_tabSec >>> .vs-tabs-position-top .vs-tabs--ul {
  width: 100%;
}
.inventory_tabSec >>> .vs-tabs--li {
  display: inline-block !important;
  width: 33.33% !important;
}
.inventory_tabSec >>> .vs-tabs--li button.vs-tabs--btn span {
  text-transform: uppercase;
}
.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-orange {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}
.header-dropdown1 {
  min-width: 180px !important;
}
.header-dropdown2 {
  min-width: 195px !important;
}
.header-dropdown3 {
  min-width: 150px !important;
}
::v-deep .vs-table--search-input {
  width: 150px !important;
}
</style>
